/**
 * Specifies the backdrop behavior for a modal window.
 */
export enum ModalBackDrop {
    /** The modal window has no backdrop. Clicking on the backdrop will dismiss the modal. */
    noneAndActive = <any>false,

    /** The modal window has a dark backdrop. Clicking on the backdrop will dismiss the modal. */
    darkAndActive = <any>true,

    /** The modal window has a dark backdrop. Clicking on the backdrop will not dismiss the modal. */
    darkAndInactive = <any>'static',
}
